import axios from "axios";
import React, { createContext, useEffect, useState } from "react";


export let packageContext = createContext();

export default function PackageContextProvider(props) {


  let headers = { token: localStorage.getItem("userToken") };
  function addPackageToCart(pckid) {
    
    return axios
      .post(
        "https://vehex-production.up.railway.app/cart/addToCart",
        {
            packageId:pckid,
          quantity:1,
        },
        {
          headers,
        }
      )
      .then((response) => response)
      .catch((error) => error);
  }
  
  function removePackage(pckid) {
    let body = {
        packageId: pckid,
    };
    return axios.delete(`https://vehex-production.up.railway.app/cart/removeCart`, {
        headers: headers, 
        data: body, 
    });
}
    function UpdatePackageQuantity(id, count) {
    let body = {
      quantity: count,
      packageId:id,
    };
    return axios.put(
        `https://vehex-production.up.railway.app/cart/updateCart`,
        body,
        {
        headers,
        }
    );
    }





  return (
    <packageContext.Provider
      value={{
        addPackageToCart,removePackage,UpdatePackageQuantity
      }}
    >
      {props.children}
    </packageContext.Provider>
  );
}
